// import HeroLogo from '../undraw_personal_website_weap.svg';
import HeroLogo from "../undraw_dev_productivity_umsq.svg";

function Hero(props) {
  const onClick = (event) => {
    event.preventDefault(); // Preventing default page reload
  };

  function scrollSmoothTo(elementId) {
    var element = document.getElementById(elementId);
    element.scrollIntoView({
      block: "start",
      behavior: "smooth",
    });
  }

  return (
    <div className="hero">
      <div className="container flex">
        <div className="hero-left">
          <h1 className="above-description">
            <strong>Hey 👋</strong>
          </h1>
          <h1 className="hero-description">
            I'm <span className="special">{props.Name}</span> and <br /> I'm a
            Software Engineer!
          </h1>
          <br />
          <div className="hire-buttons">
            <a href="#contact" className="hero-btn btn">
              Contact Me
            </a>
            <a href="#projects" className="hero-btn btn">
              Projects
            </a>
            {/* <a href={props.CVUrl} target="_blank" className="hero-btn   btn">View CV</a> */}
          </div>
          <br />
          {/* <div className="hire-buttons">
            <a href={props.LinkedinUrl} className="hero-btn btn" target="_blank">
              LinkedIn
            </a>
            <a href={props.GithubUrl} className="hero-btn btn" target="_blank">
              Github
            </a>
          </div> */}
          <div className="share-icons"></div>
        </div>

        <div className="hero-right">
          {/* <h1>Placeholder for image</h1> */}
          <img src={HeroLogo} alt="Personal website" />
        </div>
      </div>
    </div>
  );
}

export default Hero;
